// A1	问卷
// A2	本题为必答题，请作答
// A3	本题至少要选择{num}个答案
// A4	本题最多可选择{num}个答案
// A5	请在其他选项后填写内容
// A6	不少于{num}字
// A7	作答字数不足
// A8	超出最大限制文字数
// A9	{num}星
// A10	中立
// A11	感谢您的填写，我们为您准备了一份小礼物
// A12	上一题
// A13	下一题
// A14	第{num}题
// A15	您已领取奖励，点击退出返回游戏。
// A16	退出
export default {
  A1() {
    return 'QUESTIONÁRIO'
  },
  A2() {
    return 'Pergunta questão, por favor responda'
  },
  A3(num: number) {
    return `Pelo menos ${num} respostas`
  },
  A4(num: number) {
    return `Ao máximo ${num} respostas`
  },
  A5() {
    return `Por favor, preencha o conteúdo após a opção 'Outro'`
  },
  A6(num: number) {
    return `Deve ter pelos menos ${num} caracteres`
  },
  A7() {
    return `Caracteres insuficientes`
  },
  A8() {
    return `Atingiu o limite do número de caracteres`
  },
  A9(num: number) {
    return `${num} estrelas`
  },
  A10() {
    return `Neutro`
  },
  A11() {
    return `Obrigado por preencher, preparamos um presente para você!`
  },
  A12() {
    return `Anterior`
  },
  A13() {
    return `Próximo`
  },
  A14(num: number) {
    return `Qestão ${num}`
  },
  A15() {
    return `Você reivindicou sua recompensa, clique em Sair para retornar ao jogo.`
  },
  A16() {
    return `Sair`
  },
  A17() {
    return `Outro`
  },
  A20() {
    return `Confirmar`
  },
  A21() {
    return `Cancelar`
  },
  A25() {
    return `Insira`
  },
  B(key: keyof ReturnType<typeof getInfomationMap>) {
    return getInfomationMap()[key]
  },
  A26() {
    return 'A atividade expirou'
  },
}

function getInfomationMap() {
  return {
    gender: 'gênero',
    age: 'idade',
    degree: 'qualificações acadêmicas',
    city: 'cidade',
    career: 'Profissão',
    income: 'renda financeira',
    interest: 'hobby',
    marital_status: 'Estado civil',
    family_members: 'número de pessoas na familia',
    personality: 'personalidade',
    faith: 'crença',
    real_name: 'nome',
    phone: 'número de telefone',
    email: 'email',
    sport: 'esportes',
    book: 'livros',
    movie: 'filmes',
    music: 'música',
    star: 'famoso(a) favorito(a)',
    interest_city: 'cidade favorita',
    interest_country: 'País favorito',
    color: 'cor favorita',
    season: 'estação do ano',
    plant: 'planta',
    animal: 'animal',
  }
}
